import React from 'react';
import PropTypes from 'prop-types';
import { formatToCurrency } from '../../../../../_modules/currency/format_to_currency';
import { toDangerousReactHtml } from '../../../../helper/to_dangerous_react_html';
import TranslationContainer from '../../../translation/translation_container';

export const AmountDiscountPrice = ({ priceRaw, currencyIsoCode, discountValuePerItem }) => (
    <div className="buy4pay3-price">
        <div className="buy4pay3-price__value">
            <TranslationContainer
                translationKey="product-tile-current-price"
                targetProperty="dangerouslySetInnerHTML"
                transform={toDangerousReactHtml}
                placeholder={{
                    price: formatToCurrency(
                        priceRaw - discountValuePerItem,
                        currencyIsoCode,
                        false,
                        true,
                        { decimalDigits: 2 }
                    )
                }}
            >
                <span className="product-tile__price-current-value" />
            </TranslationContainer>
        </div>
    </div>
);

AmountDiscountPrice.propTypes = {
    priceRaw: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    discount: PropTypes.number.isRequired,
    discountValuePerItem: PropTypes.number,
};

AmountDiscountPrice.defaultProps = {
    discountValuePerItem: 0,
};
